import React from 'react';
import { SUPPORT_EMAIL } from './SupportEmailAddress';
interface MailToSupportLinkProps {
	label?: string;
}

const MailToSupportLink: React.FC<MailToSupportLinkProps> = ({ label = `scrivi a ${SUPPORT_EMAIL}` }) => {
	return (
		<a
			href={`mailto:${SUPPORT_EMAIL}`}
			style={{
				color: 'var(--np-primary-color)',
			}}
		>
			{label}
		</a>
	);
};

export default MailToSupportLink;
